import { defineComponent } from 'vue';
export default defineComponent({
    name: 'NoTransactions',
    setup() {
        return {};
    },
});
